import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tab-btn"
}

import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    (_unref(route).path === '/shop' || _unref(route).path === '/my' )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_link, {
            class: _normalizeClass(["_item", _unref(route).path === '/shop' ? 'on' : '']),
            to: "/shop"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "iconfont icon-a-shangchengdaohang" }, null, -1),
              _createElementVNode("div", null, "商城", -1)
            ]))]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            class: _normalizeClass(["_item", _unref(route).path === '/my' ? 'on' : '']),
            to: "/my"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "iconfont icon-a-wodedaohang" }, null, -1),
              _createElementVNode("div", null, "我的", -1)
            ]))]),
            _: 1
          }, 8, ["class"]),
          _createElementVNode("div", {
            class: _normalizeClass(["tag-bg", _unref(route).path === '/shop' ? 'on' : ''])
          }, null, 2)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})